import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectSchoolProgramCategoryModule } from 'src/shared/modules/select-school-program-category/select-school-program-category.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { StatusNoDataModule } from 'src/shared/modules/status-no-data/status-no-data.module';
import { PipeModule } from 'src/shared/pipes/pipe.module';
import { ApproverSetupComponent } from './approver-setup.component';
import { SelectYearLevelRelationV2Module } from 'src/shared/modules/select-year-level-relation-v2/select-year-level-relation-v2.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';



@NgModule({
  declarations: [ApproverSetupComponent],
  imports: [
    CommonModule,
        FeatherModule.pick(allIcons),
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    SelectSchoolLevelRelationV2Module,
    SelectSchoolProgramModule,
    SelectAcademicYearOnlyModule,
    SelectSchoolProgramCategoryModule,
    MatProgressSpinnerModule,
    MatCardModule,
    StatusNoDataModule,
    PipeModule,
    SelectYearLevelRelationV2Module,
    NgSelectModule,
    MatCheckboxModule
  ],
  exports: [ApproverSetupComponent]
})
export class ApproverSetupModule { }
